import graphqlClient from "../../../apollo";

class DepositoProvider {

    findDeposito(id) {
        return graphqlClient.query({
            query: require('./gql/depositoFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchDepositos(companyId = null) {
        if (companyId) {
            return graphqlClient.query({
                query: require('./gql/adminDepositoFetch.graphql'),
                variables: { companyId },
                fetchPolicy: "network-only"
            })
        }
        return graphqlClient.query({
            query: require('./gql/depositoFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateDepositos(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/depositoPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }



    createDeposito(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/depositoCreate.graphql'),
            variables: form
        })
    }

    updateDeposito(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/depositoUpdate.graphql'),
            variables: form
        })
    }

    deleteDeposito(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/depositoDelete.graphql'),
            variables: { id }
        })
    }

}

export default new DepositoProvider()
